<template>
  <div>
    <Header></Header>
    <div class="background">
      <div class="pay">
          <div v-html="cont"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./header";
export default {
  name: "pay",
  data() {
    return {
      id: "",
      type:"",
      cont:""
    };
  },
  created() {
    var id = this.$route.query.id;
    if(this.$route.query.type){
      var type = this.$route.query.type;
      this.type=type;
    }
    this.id = id;
  },
  methods: {
    // 文章
    async banner_detail() {
      await this.$service.home
        .banner_detail({ id: this.id,type:this.type })
        .then(res => {
          console.log(res.data);
          if (res.data.code == 200) {
            this.cont=res.data.content;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
  },
  components: {
    Header
  },
  mounted() {
    this.banner_detail();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 微导航 */
.background .pay {
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/huodong.vue